import { useQuery } from "@tanstack/react-query";
import useAuthAxios from "../utils/baseAxios";
import { API } from "../constants/api";

// Shape of GET api/naira-wallet (Nomba). Contract: NAIRA_WALLET_NOMBA.md §2.1
export type NairaWalletAccount = {
  _id: string;
  userId: string;
  nombaAccountHolderId?: string;
  nombaAccountRef?: string;
  accountNumber?: string;
  accountName?: string;
  bankName?: string;
  tier?: string;
  status: string;
  stateOfResidence?: string;
  failedFields?: string[];
  createdAt: string;
  updatedAt: string;
};

// Use this for the virtual account details only. Display the NGN balance from
// users/me (`deexWalletBalances.ngn` via useUserAsset) — that's the source of truth.
export type NairaWalletData = {
  wallet: NairaWalletAccount;
  balance: number;
  holdBalance: number;
};

export const NAIRA_WALLET_QUERY_KEY = ["naira-wallet"] as const;

const useNairaWallet = (enabled = true) => {
  const axiosInstance = useAuthAxios();

  return useQuery({
    queryKey: NAIRA_WALLET_QUERY_KEY,
    queryFn: async (): Promise<NairaWalletData> => {
      const response = await axiosInstance.get(API.getNairaWallet);
      return response.data?.data;
    },
    enabled,
    retry: 1,
  });
};

export default useNairaWallet;
